/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Day_StartInputs */

const en_features_day_start = /** @type {(inputs: Features_Day_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start workout`)
};

const pl_features_day_start = /** @type {(inputs: Features_Day_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij trening`)
};

/**
* | output |
* | --- |
* | "Start workout" |
*
* @param {Features_Day_StartInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_day_start = /** @type {((inputs?: Features_Day_StartInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Day_StartInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_day_start(inputs)
	return en_features_day_start(inputs)
});